export const config = {
  title: "Loza Construction & Landscaping",
  meta: {
    description:
      "Loza Construction & Landscaping provides professional landscaping, concrete work, fencing, and general construction services in Hayward, CA and surrounding areas.",
    keywords: [
      "Loza Construction",
      "Landscaping Hayward",
      "Concrete services",
      "Fencing Hayward",
      "Hayward CA construction",
    ],
    author: "Loza Construction & Landscaping",
    canonicalUrl: "https://www.lozaconstructionlandscaping.com/home",
  },
  sections: {
    header: {
      businessName: "Loza Construction & Landscaping",
    },
    sectionB: {
      heroTitle: "Loza Construction & Landscaping",
      heroSubtitle: "Your Trusted Local Contractor in Hayward, CA",
      learnAboutText: "View Our Work",
      phoneNumber: "5106841356",
      phoneLabel: "(510) 684-1356",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/484343309/photo/paver-in-the-garden-with-marble-plates.jpg?s=612x612&w=0&k=20&c=Di1S-zvMDCX6eR-R3nIyBbmODOZN8emufHd1fEHFayo=",
      cardData: [
        {
          title: "Concrete & Paving",
          description: "Driveways, sidewalks, patios, and other flatwork done right.",
        },
        {
          title: "Landscaping",
          description: "Cleanups, sod installation, irrigation, and decorative features.",
        },
        {
          title: "Fencing & Construction",
          description: "Wood and metal fences, gates, decks, and general construction.",
        },
      ],
      description:
        "Serving Hayward and surrounding areas, Loza Construction & Landscaping offers full-service outdoor construction including concrete work, fencing, landscaping, and more with years of experience and client satisfaction.",
    },
    sectionC: {
      servicesTitle: "Our Services",
      servicesDescription:
        "Professional outdoor construction services to bring your vision to life.",
      cards: [
        {
          title: "Concrete Work",
          description: "Patios, walkways, driveways, retaining walls and curbs.",
          imageSrc: "https://media.istockphoto.com/id/1053449478/photo/paving-blocks.jpg?s=612x612&w=0&k=20&c=_m3zC6lUaJJZDbU5yfAmL5-TK11uk-bq22IFxWcpHOg=",
          imageAlt: "Concrete Construction",
        },
        {
          title: "Landscaping",
          description: "Lawn installations, irrigation systems, trimming and cleanups.",
          imageSrc: "https://media.istockphoto.com/id/172394945/photo/landscaped-garden-retaining-wall.jpg?s=612x612&w=0&k=20&c=MSIaBurqPo8UKO_Y-SxY_AmNYw7IP_Z-nscZNj1Xy5A=",
          imageAlt: "Landscaping Services",
        },
        {
          title: "Fencing & General Building",
          description: "Wood fencing, decks, gates and construction improvements.",
          imageSrc: "https://media.istockphoto.com/id/1340944064/photo/flowerbed.jpg?s=612x612&w=0&k=20&c=9Wz3W2w7nGQPmlQmNuOl4CrhShPfJSZt2iK-eze_OWk=",
          imageAlt: "Fencing and Construction",
        },
      ],
      otherServicesTitle: "Additional Services",
      otherServicesList: [
        "Cleanups & Maintenance",
        "Sod & Mulch Installation",
        "Irrigation Systems",
        "Block & Retaining Walls",
        "Paver Installation",
      ],
    },
    sectionD: {
      aboutTitle: "About Us",
      aboutImage: {
        src: "https://cdn.builder.io/api/v1/image/assets%2Fad2d90eaf7294c30910dab36449c77d0%2F5479fe352c484b248012d36c4292bb8a",
        alt: "Loza Construction Crew",
      },
      aboutText: [
        "Loza Construction & Landscaping is a trusted Hayward-based company with years of experience in outdoor construction and landscape design.",
        "We take pride in exceeding client expectations with every project — from small cleanups to complete concrete or landscaping transformations.",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "Loza Construction & Landscaping Logo",
      businessName: "Loza Construction & Landscaping",
      contact: {
        phone: "5106841356",
        phoneLabel: "(510) 684-1356",
        email: "juanjloza2013@gmail.com",
        website: "https://www.lozaconstructionlandscaping.com/home",
        address: "Hayward, CA",
      },
      socialMedia: {
        facebook: null,
        instagram: null,
        twitter: null,
        linkedin: null,
        youtube: null,
      },
    },
    sectionF: {
      address: "Hayward, CA",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3156.5685471381774!2d-122.08079618468333!3d37.66882097977024!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x808f9331fd1f3b1d%3A0xf093d1832038a18a!2sHayward%2C%20CA!5e0!3m2!1sen!2sus!4v1710000000000!5m2!1sen!2sus",
    },
  },
};

export default config;
